import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { CheckmarkCircle, MinusCircled, PauseCircled, Truck, Plane } from '@bibliocommons/base-icons';
import BorrowingStatusIcon from '../../shared/BorrowingStatusIcon';


const getIcon = (status) => {
  switch (status) {
    case 'READY':
      return <CheckmarkCircle />;
    case 'IN_TRANSIT':
      return <Truck />;
    case 'INACTIVE':
      return <PauseCircled />;
    case 'SHIPPED':
      return <Plane />;
    default:
      return <MinusCircled />;
  }
};


export default function InterlibraryLoansStatusIcon({ status, withBackground, withLabel }) {
  const label = (
    status && <FormattedMessage id={`ill_status_${status.toLowerCase()}`} />
  );

  return (
    <BorrowingStatusIcon
      className="cp-interlibraryloans-status-icon"
      icon={getIcon(status)}
      status={status}
      withBackground={withBackground}
      renderLabel={withLabel && (() => label)} />
  );
}

InterlibraryLoansStatusIcon.propTypes = {
  status: PropTypes.string.isRequired,
  withBackground: PropTypes.bool,
  withLabel: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/interlibraryLoans/InterlibraryLoansStatusIcon/InterlibraryLoansStatusIcon.jsx